__turbopack_context__.v({
  "active": "Scs_Bq_active",
  "credabilityLogo": "Scs_Bq_credabilityLogo",
  "ctaWithGradient": "Scs_Bq_ctaWithGradient",
  "menuLink": "Scs_Bq_menuLink",
  "navHeader": "Scs_Bq_navHeader",
  "navHeaderContainer": "Scs_Bq_navHeaderContainer",
  "navigation": "Scs_Bq_navigation",
  "navigationLinkCore": "Scs_Bq_navigationLinkCore",
  "navigationList": "Scs_Bq_navigationList",
  "navigationListItem": "Scs_Bq_navigationListItem",
  "navigationListItemActive": "Scs_Bq_navigationListItemActive",
});
